<template>
    <div class="container">
        <!-- <div >
             <div >
                <a href="#"><img src="assets/images/header/IEHlogo.png" alt=""></a>
            </div>          
        </div> -->
        <div class="row">
            <div>
                <h1 style="margin-top:30px; margin-bottom: 30px;">Casetas</h1>

                <p class="about-four__text justifi " style="margin-bottom: 30px;">Este controlador está diseñado para ser instalado en la caseta de riego y ser el reemplazo
                directo del o los antiguos programadores de riego. Con este equipo podrá mantener su
                antiguo sistema de válvulas cableadas evitando la instalación de nodos en cada válvula.
                </p>
            </div>
        </div>
        <div class="row">
            <div class="col-xl-6 col-lg-6 col-md-6">
                <ul class="list-unstyled feature-one__point">
                    <li>
                        <div >
                             <span class="fa fa-check"></span>
                        </div>
                         <div class="justifi2">
                            <p >Reemplaza directamente el programador de riego convencional.</p>
                         </div>
                    </li>
                    <li>
                        <div >
                             <span class="fa fa-check"></span>
                        </div>
                         <div class="justifi2 justifi">
                            <p >Controla hasta 10 sectores (expandibles) de riego cableados hasta las válvulas.</p>
                         </div>
                    </li>
                    <li>
                        <div >
                             <span class="fa fa-check"></span>
                        </div>
                         <div class="justifi2">
                            <p >Hasta 8 caudalímetros.</p>
                         </div>
                    </li>
                    <li>
                        <div >
                             <span class="fa fa-check"></span>
                        </div>
                         <div class="justifi2">
                            <p >Partida de motores.</p>
                         </div>
                    </li>
                </ul>
                  <!-- <i class="fas fa-check"></i> -->
                  <!-- <i class="far fa-check-circle"></i> -->
            </div>
            <!-- 2 -->
            <div class="col-xl-6 col-lg-6 col-md-6">
                <ul class="list-unstyled feature-one__point">
                    <li>
                        <div >
                             <span class="fa fa-check"></span>
                        </div>
                         <div class="justifi2">
                            <p >Medición de caudal y volumen de agua utilizada por sector de riego.</p>
                         </div>
                    </li>
                    <li>
                        <div >
                             <span class="fa fa-check"></span>
                        </div>
                         <div class="justifi2">
                            <p>Seteo de parámetros máximos y mínimos para caudal y presión.</p>
                         </div>
                    </li>
                    <li>
                        <div >
                             <span class="fa fa-check"></span>
                        </div>
                         <div class="justifi2">
                            <p>Programación y visualización de datos en vivo a través de plataforma web.</p>
                         </div>
                    </li>
                    <li>
                        <div >
                             <span class="fa fa-check"></span>
                        </div>
                         <div class="justifi2">
                            <p >Órdenes de trabajo, reportes, informes y mucho más.</p>
                         </div>
                    </li>
                </ul>
            </div>
        </div>
        <div class="row">
            <p class="justifi" style="margin-bottom: 30px">
                Obtén el control total de tu sistema de riego desde la comodidad de tu teléfono o computadora.
            </p>
        </div>

    </div>
</template>
    <style>
        .justifi{
            text-align: justify;
            
        }
        .justifi2{
            text-align: justify;
            font-family: Arial, Helvetica, sans-serif !important; 
            font-weight: 0px !important;
            color: #2c3e50 !important;
            margin-left: 14px;
        }

            @media only screen and (max-width: 1024px){
                .px-5 {
                    padding-right: 0rem!important;
                    padding-left: 0rem!important;
                }
            }
    </style>
<script>
</script>